import Card from '../../components/card/Card';
import H from '../../components/texts/h/H';
import P from '../../components/texts/p/P';
import Input from '../../components/input/Input';
import DatePicker from '../../components/datepicker/DatePicker';
import DropDown from '../../components/dropdown/DropDown';
import { MonetizationFormData, FormValues } from '../../pages/MonetizationNew';

interface GeneralSectionProps {
  formData: MonetizationFormData;
  formValues: FormValues;
  updateFormValues: (updates: Partial<FormValues>) => void;
}

const GeneralSection = ({ formData, formValues, updateFormValues }: GeneralSectionProps) => {
  // Helper functions for dropdown
  const guaranteeTypeItems = formData.guarantee_types?.map(guaranteeType => ({
    label: guaranteeType.name,
    disabled: false
  })) || [];

  const getSelectedGuaranteeTypeName = () => {
    const selectedType = formData.guarantee_types?.find(gt => gt.id === formValues.guarantee_type_id);
    return selectedType ? selectedType.name : 'Seleccionar';
  };

  const handleGuaranteeTypeChange = (selectedLabel: string) => {
    const guaranteeType = formData.guarantee_types?.find(gt => gt.name === selectedLabel);
    if (guaranteeType) {
      updateFormValues({ guarantee_type_id: guaranteeType.id });
    }
  };

  return (
    <Card margin={{ bottom: '4' }}>
      <Card margin={{ bottom: '3' }}>
        <H variant="secondary-2" type='4' weight='bold' modifier='strong'>
          General
        </H>
      </Card>
      
      {/* Fila 1 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 4fr 2fr 2fr 0fr', gap: '16px', marginBottom: '24px', alignItems: 'end' }}>
        <Input
          label="Número de línea"
          value={formValues.product_line_id}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="Razón social"
          value={formData.company_name}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="CUIT"
          value={formData.cuit}
          readOnly
          size="md"
          modifier="weak"
        />
        <DropDown
          id="guarantee_type"
          label="Tipo de operación"
          title={getSelectedGuaranteeTypeName()}
          items={guaranteeTypeItems}
          onChange={handleGuaranteeTypeChange}
          size="md"
          marginTop="4px"
        />
        <div>
          <Input
            value={formData.guarantee_types?.find(gt => gt.id === formValues.guarantee_type_id)?.type || ''}
            readOnly
            size="xs"
            modifier="weak"
          />
        </div>
      </div>

      {/* Fila 2 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', alignItems: 'end' }}>
        <Input
          label="Tipo de garantía"
          value={formData.guarantee_types?.find(gt => gt.id === formValues.guarantee_type_id)?.label || ''}
          readOnly
          size="md"
          modifier="weak"
        />
        <Card>
          <P withMargin={false} variant='neutral' type='4' modifier='strong'>
            Fecha de carga *
          </P>
          <Card margin={{ top: '2' }}>
            <DatePicker
              defaultValue={formValues.created_at || new Date().toISOString().split('T')[0]}
              onChange={() => {}}
              disabled={true}
              displayFormat="DD/MM/AA"
            />
          </Card>
        </Card>
      </div>
    </Card>
  );
};

export default GeneralSection;